module.exports = __webpack_public_path__ + "static/media/1011929.51c4471c.png";